<template>
  <div
    class="career-job-positions-wrapper my-large"
    data-test-id="component-career-job-positions"
  >
    <div class="container">
      <div class="flex flex-wrap  -mx-tiny">
        <div class="block w-full px-standart">
          <h2 class="h4 mb-standart">
            {{ $messages('about.career.open_positions') }}
          </h2>
          <p class="h2">
            {{ $messages('about.career.show_jobs_in') }}
          </p>
        </div>
        <div class="block w-full px-standart">
          <div class="flex md:block flex-wrap border-b-1 border-midnight-gray/25">
            <button
              v-for="(location, locationIndex) in jobsLocation"
              :key="locationIndex"
              :class="[
                locationIndex === selectedLocationIndex ? 'border-infra-violette text-dark/muted' : 'border-white',
                'flex-grow text-center',
                'px-standart py-micro',
                'text-bigger border-b-8',
                'focus:outline-none hover:border-infra-violette',
                'transition-colors duration-100'
              ]"
              data-test-id="button-career-job-positions-job-location"
              @click="selectedLocationIndex = locationIndex"
            >
              {{ location }}
            </button>
          </div>
          <div class="flex flex-wrap  -mx-tiny mt-tiny">
            <template
              v-for="(job, index) in jobsInSelectedLocation"
              :key="index"
            >
              <div
                cols="12"
                class="job-department hidden relative w-full px-standart"
                :class="{
                  'lg:block': isJobsWithDifferentDepartment(job, jobsInSelectedLocation[index-1])
                }"
                :data-test-id="`block-career-job-department-${index}`"
              >
                <h3
                  class="h3 my-standart"
                  :data-test-id="`text-career-job-department-${index}`"
                >
                  {{ job.department }}
                </h3>
              </div>
              <div
                class="block w-full md:w-1/2 lg:w-1/4 px-standart"
              >
                <AboutCareerJobItem
                  :title="job.title"
                  :city="job.city"
                  :slug="job.slug"
                />
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  setup () {
    const jobsApi = useJobs()
    return {
      jobsApi
    }
  },
  data () {
    return {
      isLoading:false,
      allLocation: this.$messages('about.career.job_location_all'),
      selectedLocationIndex: 0,
      jobs: []
    }
  },
  async mounted () {
    this.isLoading = true
    this.jobs = await this.jobsApi.getJobs();
    this.jobs.sort((a, b) => {
          if (a.department === b.department) {
            return a.title > b.title ? 1 : -1
          }
          return a.department > b.department ? 1 : -1
        })
    this.isLoading = false
  },
  computed: {
    jobsLocation () {
      if (this.jobs.length === 0) { return [] }

      const locations = [...new Set(this.jobs.map(x => x.location).reduce((p, c) => [...p, ...c], []))]
      locations.unshift(this.allLocation)

      return locations
    },
    jobsInSelectedLocation () {
      const location = this.jobsLocation[this.selectedLocationIndex]

      if (this.allLocation === location) { return this.jobs }

      return this.jobs.filter(x => x.location.includes(location))
    }
  },
  methods: {
    getJobsPerLocation (location) {
      if (this.allLocation === location) { return this.jobs }

      return this.jobs.filter(x => x.location.includes(location))
    },
    isJobsWithDifferentDepartment (jobA, jobB) {
      if (!jobA && !jobB) {
        return false
      }

      if (!jobA || !jobB) {
        return true
      }

      return jobA.department !== jobB.department
    }
  }
}
</script>
